import auth0 from 'auth0-js';
import {renewSuccess, logout} from '../actions'
import {getStore} from '../store'
import {getCurrentHost} from "../utils/url";

export default class Auth {
    auth0 = new auth0.WebAuth({
        domain: process.env.REACT_APP_AUTHO_DOMAIN,
        clientID: process.env.REACT_APP_AUTHO_CLIENT_ID,
        redirectUri: getCurrentHost()+process.env.REACT_APP_AUTHO_CALLBACK_URL,
        //audience: `https://${process.env.REACT_APP_AUTHO_DOMAIN}/userinfo`,
        audience: process.env.REACT_APP_AUTHO_AUDIENCE,
        responseType: 'token id_token',
        scope: 'openid profile email'
    });

    constructor() {
        this.login = this.login.bind(this);
        this.signup = this.signup.bind(this);
        this.loginWithGoogle = this.loginWithGoogle.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuthentication = this.handleAuthentication.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.checkRenewedToken = this.checkRenewedToken.bind(this);
        this.tokenRenewalTimeout = undefined;

        this.scheduleRenewal();
    }

    register(userType) {
        const params = {
            user_type: userType,
            redirectUri: getCurrentHost() + process.env.REACT_APP_AUTHO_CALLBACK_URL + "?user_type=" + userType,
            initialScreen: 'signUp'
        };
        this.auth0.authorize(params);
    }

    registerEmployee(userType) {
        var params = {
            connection: 'Username-Password-Authentication',
            initialScreen: 'signUp',
            prefillUsername: "@evoenergy.com.au",
        };
        this.auth0.authorize(params);
    }

    forgetPassword() {
        const params = { initialScreen: 'forgotPassword' };
        this.auth0.authorize(params);
    }

    authoriseEmployee() {
        var params = {
            connection: 'Username-Password-Authentication'
        };
        this.auth0.authorize(params);
    }

    authorise() {
        this.auth0.authorize();
    }

    login(username, password) {
        this.auth0.login(
            { realm: process.env.REACT_APP_AUTHO_DB_CONNECTION_NAME, username, password },
            (err, authResult) => {
                if (err) {
                    console.log(err);
                    alert(`Error: ${err.description}. Check the console for further details.`);
                    return;
                }
            }
        );
    }

    signup(email, password) {
        this.auth0.signup(
            { connection: process.env.REACT_APP_AUTHO_DB_CONNECTION_NAME, email, password },
            (err) => {
                if (err) {
                    console.log(err);
                    alert(`Error: ${err.description}. Check the console for further details.`);

                    return;
                }

                this.auth0.login({ realm: process.env.REACT_APP_AUTHO_DB_CONNECTION_NAME, username: email, password },
                    (err, authResult) => {
                        if (err) {
                            console.log(err);
                            alert(`Error: ${err.description}. Check the console for further details.`);
                            return;
                        }
                    }
                );
            }
        );
    }

    loginWithGoogle() {
        this.auth0.authorize({ connection: 'google-oauth2' });
    }

    handleAuthentication(callback) {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
                // Profile comes with the auth request
                //this.getProfile((err, profile) => console.log(profile));
                let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
                callback(null, {
                    ...authResult,
                    expiresAt
                });
            } else if (err) {
                callback(err, null);
                console.log(err);
            }
        });
    }

    setSession(authResult) {
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
        localStorage.setItem('authResult', JSON.stringify(authResult));
        this.scheduleRenewal();
    }

    logout() {
        // Clear access token and ID token from local storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('authResult');
        if(this.tokenRenewalTimeout)
            clearTimeout(this.tokenRenewalTimeout);
    }

    isAuthenticated() {
        // Check whether the current time is past the
        // access token's expiry time
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        return new Date().getTime() < expiresAt;
    }

    getAccessToken() {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            throw new Error('No access token found');
        }
        return accessToken;
    }

    getAuthResult() {
        var str = localStorage.getItem('authResult');
        if(str) return JSON.parse(str);
    }

    getProfile(cb) {
        let accessToken = this.getAccessToken();
        this.auth0.client.userInfo(accessToken, (err, profile) => {
            if (profile) {
                this.userProfile = profile;
            }
            cb(err, profile);
        });
    }

    scheduleRenewal() {
        const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        const delay = expiresAt - Date.now();
        //const delay = 5000;

        if(this.tokenRenewalTimeout)
            clearTimeout(this.tokenRenewalTimeout);

        if (delay > 0) {
            this.tokenRenewalTimeout = setTimeout(() => {
                this.renewToken();
            }, delay);
        }
    }

    renewToken() {
        console.log(process.env.REACT_APP_AUTHO_AUDIENCE)
            this.auth0.renewAuth(
            {
                audience: process.env.REACT_APP_AUTHO_AUDIENCE,
                redirectUri: getCurrentHost() + process.env.REACT_APP_AUTHO_CALLBACK_RENEW_URL,
                usePostMessage: true
            }, (err, result) => {
                if (err) {
                    //TODO should i log out here
                    console.error(err);
                    getStore().dispatch(logout())
                } else {
                    if(result.error)
                    {
                        console.error(result);
                        getStore().dispatch(logout())
                    }
                    else {
                        this.setSession(result);
                        let expiresAt = JSON.stringify((result.expiresIn * 1000) + new Date().getTime());
                        getStore().dispatch(renewSuccess({
                            ...result,
                            expiresAt
                        }))
                    }
                }
            }
        );
    }

    checkRenewedToken() {
        this.auth0.parseHash(window.location.hash, function (err, response) {
            window.parent.postMessage(err || response, '*');
        });
    }

}


// WEBPACK FOOTER //
// ./src/auth/Auth.js